export default __webpack_public_path__ + "static/media/Boots of the Judgment Bolt.7d8405b7.jpg";